import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ToastController } from 'ionic-angular';
import { User } from '../../model/UserModel';
import { UserService } from '../../services/UserService';
import { ProjectUserModel } from '../../model/CronosModel';

@IonicPage()
@Component({
  selector: 'page-cronos-members-add',
  templateUrl: 'cronos-members-add.html',
})
export class CronosMembersAddPage {

  public searchInput: string;
  public shouldShowCancelSearch: boolean;
  public originalMembers: Array<ProjectUserModel>;
  public filteredUsers: Array<User>;
  public clientId: number;
  public isLoading: boolean;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private userService: UserService
  ) {
    this.clientId = this.navParams.get('clientId');
    this.originalMembers = this.navParams.get('members');
    this.isLoading = false;
    this.search();
  }

  search() {
    if (this.searchInput != null && this.searchInput != '') {
      this.isLoading = true;
      this.userService.findUserByName(this.searchInput, this.clientId).subscribe(
        res => {
          this.filteredUsers = res;
          this.isLoading = false;
        },
        err => {
          this.presentToast('Houve um erro ao pesquisar o usuário');
          this.isLoading = false;
        }
      );
    } else {
      this.filteredUsers = [];
    }
  }

  cancelSearch() {
    this.searchInput = null;
    this.shouldShowCancelSearch = false;
    this.search();
  }

  jaVinculado(userId: number): boolean {
    return this.originalMembers.find(x => x.userId == userId) != null;
  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  addMember(user: User) {
    if (this.jaVinculado(user.id)) {
      this.presentToast('Usuário já vinculado');
    } else {
      this.viewCtrl.dismiss(user);
    }
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });  
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-members-add/cronos-members-add.ts